// app/javascript/application.js
import "@hotwired/turbo-rails"
import "./controllers"
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './components/App'

let appRoot = null;

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('root');
  if (rootElement && !appRoot) {
    appRoot = createRoot(rootElement);
    appRoot.render(<App />);
  }
});

document.addEventListener('turbo:before-render', () => {
  if (appRoot) {
    appRoot.unmount();
    appRoot = null;
  }
});
